import { CSSProperties, useEffect } from 'react';

import { ApiStatus, NotificationPosition } from 'core/enums';
import { useNotificationContext } from 'core/states';

import NotificationView from './NotificationView';

const SHOW_NOTIFICATION_TIME = 5000; // 5 seconds

const TYPES_WITH_TIMER = [ApiStatus.SUCCESS, ApiStatus.ERROR];

interface IProps {
  position: NotificationPosition;
  style?: CSSProperties;
}

export const Notification = ({ position, style }: IProps) => {
  const { notification, clearNotification } = useNotificationContext();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    const shouldAutoClose =
      notification &&
      ((TYPES_WITH_TIMER.includes(notification.type) && !notification.disableAutoClose) ||
        notification.autoClose);

    if (shouldAutoClose) {
      timer = setTimeout(() => clearNotification(), SHOW_NOTIFICATION_TIME);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [notification, clearNotification]);

  if (notification?.position !== position) {
    return null;
  }

  return (
    <NotificationView
      {...notification}
      style={style}
      showNotification={notification?.position === position}
    />
  );
};

export default Notification;
